import { FC, PropsWithChildren } from "react"
import style from "./Mbt.module.css"

/** Module Box Text */
export const Mbt: FC<PropsWithChildren> = ({ children }) => {
	return <p className={style.mbt}>{children}</p>
}
